import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "../../lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    noAnimation?: boolean
    label?: string
  }
>(({ className, value, noAnimation, label, ...props }, ref) => (
  <div className="w-full relative">
    {label && (
      <div className={cn("text-xs text-background absolute top-0 left-1/2 -translate-x-1/2 z-10")}>
        {label}
      </div>
    )}
    <ProgressPrimitive.Root
      ref={ref}
      aria-label={label}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          "progress-indicator h-full w-full flex-1 bg-primary relative overflow-hidden",
          !noAnimation && "transition-all"
        )}
        style={
          {
            "--progress-translate": `-${100 - (value || 0)}%`,
          } as React.CSSProperties
        }
      >
        {!noAnimation && (
          <div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(90deg, transparent 0%, transparent 40%, rgba(255, 255, 255, 0.4) 50%, transparent 60%, transparent 100%)',
              backgroundSize: '200% 100%',
              backgroundPosition: '200% 0',
              animation: 'shimmer 2s infinite linear'
            }}
          />
        )}
      </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
  </div>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
